import { receiveError } from '../redux/actions/errors';


const genericApiErrorHandler = function genericApiErrorHandlerFunction(error, dispatch) {
  dispatch(receiveError(error));
};

export default genericApiErrorHandler;
